import React, { useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import CheckoutPageContext from '../../context/CheckoutPageContext';
import useSwitchesFromContext from '../../hooks/useSwitchesFromContext';
import RecognizeCustomer from './recognize-customer/recognize-customer';
import StickyBagSummary from './StickyBagSummary/StickyBagSummary';
import PurchaseSiteHeader from '../Common/PurchaseSiteHeader/PurchaseSiteHeader';

export function CheckoutTopRail() {
  const { getSwitchValue } = useSwitchesFromContext();
  const isCheckoutStickyNavEnabled = getSwitchValue('chkStickyBagSummary');
  const useRecognizeCustomer = getSwitchValue('chkMfeRecognizeCustomer');
  const {
    checkoutPageState,
  } = useContext(CheckoutPageContext);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) { return null; }

  return (
    <div className="checkout-mfe-web-service">
      <PurchaseSiteHeader brand={checkoutPageState?.brand} />
      {checkoutPageState?.bagItems
       && isCheckoutStickyNavEnabled && (
       <StickyBagSummary
         isAppWebView={checkoutPageState?.deviceInfo?.isAppWebView}
         bagItems={checkoutPageState?.bagItems}
         tmntData={checkoutPageState?.textFor}
         orderTotals={checkoutPageState?.orderTotals}
         config={checkoutPageState?.config}
         shipMethod={checkoutPageState?.shipMethod}
         giftCards={checkoutPageState?.giftCards}
         vatDetails={checkoutPageState?.vatDetails}
       />
      )}
      <PurchaseSiteHeader spacer />
      {useRecognizeCustomer
        && !checkoutPageState?.userData?.isLoggedIn
        && !checkoutPageState?.deviceInfo?.isAppWebView
        && <RecognizeCustomer />}
    </div>
  );
}

function CheckoutTopRailPortal() {
  const id = 'checkout-top-rail-mfe-portal';
  if (typeof document !== 'undefined' && !!document.getElementById(id)) {
    return ReactDOM.createPortal(
      <CheckoutTopRail />,
      document.getElementById(id),
    );
  }
  return null;
}

export default CheckoutTopRailPortal;
